import { deriveProjectAssets } from "../../utils/projectAssets";

// Only a completed electrical design supplies the percentage basis. Never use
// autoDesign.targetCapacityKw (or the legacy capacity field without a design).
export function installedPvKw(config) {
  if (!deriveProjectAssets(config).hasPv) return null;
  const designKw = Number(config?.pv_design?.capacityKw);
  if (Number.isFinite(designKw) && designKw > 0) return designKw;
  if (!Object.keys(config?.systemDesign || {}).length) return null;
  const kw = Number(config?.pvInstalledCap?.kw);
  return Number.isFinite(kw) && kw > 0 ? kw : null;
}

export function percentageExportKw(config) {
  const kw = installedPvKw(config);
  const percent = Number(config?.grid?.exportLimitPercent);
  return kw !== null && Number.isFinite(percent) && percent > 0 && percent <= 100
    ? Number((kw * percent / 100).toFixed(6)) : null;
}

// Keep exportLimitKw materialised for all existing backend consumers. Applying
// this at history/persistence boundaries also works with the grid tab closed.
export function reconcileGridExportLimit(config) {
  if (!config) return config;
  let next = config;
  if (config.grid?.exportLimitMode === "pv_percent") {
    const kw = percentageExportKw(config);
    // If the design is removed (or the asset becomes BESS-only), retain the
    // last concrete connection cap as kW rather than silently make it unlimited.
    if (kw === null) next = { ...config, grid: { ...config.grid, exportLimitMode: "kw" } };
    if (kw !== null && kw !== config.grid.exportLimitKw) {
      next = { ...config, grid: { ...config.grid, exportLimitKw: kw } };
    }
  }
  if (Array.isArray(config.portfolio?.assets)) {
    const assets = config.portfolio.assets.map(asset => {
      const updated = reconcileGridExportLimit(asset.config);
      return updated === asset.config ? asset : { ...asset, config: updated };
    });
    if (assets.some((asset, i) => asset !== config.portfolio.assets[i])) {
      next = { ...next, portfolio: { ...next.portfolio, assets } };
    }
  }
  return next;
}
